<template>
	<div class="packages-component" v-if="providers">

<!--		<a class="promo-banner mb-50" @click.prevent="showFreezeModal()">-->
<!--			<picture>-->
<!--				<source media="(max-width: 600px)" :srcset="`${assetBase}/assets/freeze/2024/packages-mobile.png, ${assetBase}/assets/freeze/2024/packages-mobile@2x.png 2x`">-->
<!--				<source media="(min-width: 601px)" :srcset="`${assetBase}/assets/freeze/2024/packages.png, ${assetBase}/assets/freeze/2024/packages@2x.png 2x`">-->
<!--				<img style="display: block;" :src="`${assetBase}/assets/freeze/2024/packages.png`" alt="">-->
<!--			</picture>-->
<!--		</a>-->
		<provider-slider :providers="providers" :selected-provider="selectedProvider" @update="selectProvider"></provider-slider>
		<products :provider="selectedProvider"></products>
		<experience-bar></experience-bar>

<!--		<div class="product-notice" v-if="selectedProvider.slug === 'vuma-reach'">-->
<!--			<svg class="icon"><use xlink:href="#exclaim-circle"></use></svg>-->
<!--			<dl>-->
<!--				<dt>Upcoming Price increases.</dt>-->
<!--				<dd>All Vuma Reach package prices will increase from 01 April 2025. If you sign up before April, your package price will increase from the following month after signup.</dd>-->
<!--			</dl>-->
<!--		</div>-->

		<div class="promo-banner" v-if="promo">
			<picture style="display: block;">
				<source media="(max-width: 600px)" :srcset="`${promo.packagesMobile}, ${promo.packagesMobile2x} 2x`">
				<source media="(min-width: 601px)" :srcset="`${promo.packages}, ${promo.packages2x} 2x`">
				<img style="display: block;" :src="`${promo.packages}`" alt="">
			</picture>
		</div>


		<signup-bar :provider="selectedProvider"></signup-bar>

	</div><!-- end.packages-component -->
</template>

<script>
	import Products from '../components/Products'
	import SignupBar from '../components/SignupBar'
	import ExperienceBar from '../components/ExperienceBar'
	import ProviderSlider from '../components/ProviderSlider'

	export default {
		components: {
			Products,
			SignupBar,
			ExperienceBar,
			ProviderSlider,
		},
		computed: {
			providers() {
				return this.$store.getters['providers/providers'];
			},
			assetBase() {
				return window._assetBaseUrl;
			},
			promo() {
				if(!this.selectedProvider.promos || !this.selectedProvider.promos.length) return false

				return this.selectedProvider.promos[0].assets
			}
		},
		methods: {
			selectProvider(provider) {
				this.selectedProvider = provider;
				this.$store.commit('general/updateShowRouters', (provider.slug !== 'vuma-reach' && provider.slug !== 'openserve-web-connect' && provider.slug !== 'frogfoot-air'));
			},
			showUpgradeModal() {
				this.$store.commit('general/updateUpgradeModalVisibility', true);
			},
			showFreezeModal() {
				this.$store.commit('general/updateFreezeModalVisibility', true);
			}
		},
		data() {
			return {
				selectedProvider: false
			}
		},
	}
</script>
